import styled from "styled-components";
import {
  BottomNavigation,
  BottomNavigationAction,
  Tabs as MuiTabs,
} from "@mui/material";

interface MobileProps {
  isMobile?: boolean;
}

export const Container = styled.div<MobileProps>`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
`;

export const DesktopHeader = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  max-width: 900px;
  height: 100%;
`;

export const MainContent = styled.main`
  flex: 1;
  overflow-y: auto;
`;

export const ContentContainer = styled.div<MobileProps>`
  max-width: ${({ isMobile }) => (isMobile ? "100%" : "900px")};
  margin: ${({ isMobile }) => (isMobile ? "0" : "0 auto")};
  width: 100%;
`;

export const LogoImage = styled.img`
  width: auto;
  height: 3.5rem;
  margin-left: 1.5rem;
`;

export const DesktopTabs = styled(MuiTabs)`
  margin-right: 1rem;
  && {
    .MuiTab-root {
      min-height: 64px;
      font-size: 1rem;
      font-weight: 500;
    }
  }
`;

export const MobileBottomNav = styled(BottomNavigation)`
  && {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    background-color: #fff;
  }
`;

export const MobileTab = styled(BottomNavigationAction)`
  && {
    min-width: auto;
    padding: 6px 12px;
  }
`;
